import apiConf from "./apiConfiguration";
import net from "./net";

const apiSkills = {
    get() {
       return net.get(apiConf.endpoint("/skills/")).then((response) => response);
    }
};

export default apiSkills;